import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Leaf } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/login");
            return;
        }
        const sessionId = decodeURIComponent(match[1]);

        (async () => {
            try {
                const res = await api.post(
                    "/auth/session",
                    {},
                    { headers: { "X-Session-ID": sessionId } }
                );
                setUser(res.data);
                window.history.replaceState(null, "", "/dashboard");
                navigate("/dashboard", { replace: true, state: { user: res.data } });
            } catch {
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center" style={{ background: "var(--nl-bg)" }}>
            <Leaf className="w-10 h-10 animate-pulse" style={{ color: "#3B824E" }} />
            <p className="mt-4 font-eyebrow">Signing you in</p>
        </div>
    );
}
